import { atom } from "recoil"
import { AppVersion } from "src/types/maintenanceUpdate/AppVersion"

export const appVersionsState = atom<AppVersion[] | undefined>({
  key: "atoms/updateApp/appVersionsState",
  default: undefined,
})
